// extracted by mini-css-extract-plugin
module.exports = {"root":"Map_root__gMAKx","marker":"Map_marker__NAmGW","marker__label":"Map_marker__label__1-8kO"};